<template>
  <div :class="'q-ma-lg news-area ' + (displayScreen === '0' ? 'login' : '')">
    <label>お知らせ</label>
    <q-skeleton v-if="isSkeleton" square class="news-area-skeleton"></q-skeleton>
    <q-scroll-area v-else class="news-area-scroll" visible>
      <!--お知らせ取得件数0件の場合-->
      <div v-if="news.length === 0">現在新たなお知らせはありません。</div>
      <div v-for="item in news" :key="item.news_id" class="column q-pb-md">
        <q-separator color="secondary" size="2px" class="q-mb-sm" />
        <p>{{ item.publish_date }}</p>
        <label class="news-area-title">{{ item.news_title }}</label>
        <div class="news-area-body">{{ item.news_body }}</div>
      </div>
    </q-scroll-area>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';

interface Props {
  // 表示画面(ログイン：0 TOP：1)
  displayScreen: string;
}

interface News {
  news_id: string;
  publish_date: string;
  news_title: string;
  news_body: string;
}

const props = defineProps<Props>();
const router = useRouter();

// お知らせ情報
let news: News[] = [];

// Skeletonフラグ
const isSkeleton = ref(true);

/**
 * お知らせ情報取得
 */
const getNewsInfo = async () => {
  // 検索条件設定
  const formData = new FormData();
  formData.append('display_screen', props.displayScreen);

  // お知らせ情報取得
  await axios
    .post('/news', formData)
    .then((res) => {
      const { common, newsInfoList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          news = newsInfoList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // 必須入力エラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch(() => {
      // エラー画面に遷移
      router.push({ name: 'error' });
    })
    .finally(() => {
      isSkeleton.value = false;
    });
};

/**
 * 初期処理
 */
getNewsInfo();
</script>

<style scoped>
.news-area {
  width: 80%;
  padding: 10px 1.2rem;
  margin-bottom: 0;
  border: 1px solid var(--q-primary);
  border-radius: 5px;
  background: var(--q-white);
}
.news-area > label {
  font-weight: 600;
  font-size: 1.1rem;
  color: var(--q-primary);
}
.news-area p {
  margin-bottom: 0.2rem;
  font-size: 0.75rem;
}
.news-area .news-area-title {
  font-size: 1.1rem;
}
.news-area .news-area-body {
  word-break: break-all;
  white-space: pre-wrap;
}
.news-area .news-area-skeleton {
  height: 200px;
}
.news-area .news-area-scroll {
  height: 240px;
  width: 100%;
}

.news-area.login .news-area-scroll {
  height: 180px;
  width: 100%;
}
</style>
